type Location = 'North Shore' | 'Honolulu' | 'Other';

export interface AccommodationData {
  path: string;
  name: string;
  location: Location;
  address?: string;
  mapUrl?: string;
  roomRate?: string;
  promoCode?: string;
  travelTime?: number;
  url: string;
  imgPath: string;
  description: string;
}

export const accommodations: AccommodationData[] = [
  {
    path: '/accommodations/turtlebay',
    name: 'Turtle Bay Resort',
    location: 'North Shore',
    address: '57-091 Kamehameha Highway, Kahuku',
    mapUrl: 'https://goo.gl/maps/cfWYZWe53DM2',
    roomRate: 'TBD',
    promoCode: '-',
    travelTime: 37,
    url: 'http://turtlebayresort.com',
    imgPath: '/img/accommodations_turtlebay.jpg',
    description: 'Details to come.',
  },
  {
    path: '/accommodations/halekoa',
    name: 'Hale Koa',
    location: 'Honolulu',
    address: '2055 Kalia Rd, Honolulu',
    mapUrl: 'https://goo.gl/maps/MYeobBH2x5A2',
    roomRate: 'Category II $184',
    promoCode: 'N/A',
    travelTime: 55,
    url: 'https://halekoa.com',
    imgPath: '/img/accommodations_halekoa.jpg',
    description:
      "Available for active duty, retired or government service members. Matt may also sponsor a limited amount of \
      friends and family. Friends and family will receive the Category II rate for an active duty 0-3. Room \
      reservations will not be accepted more than 365 days in advance. Please reach out and let us know if you're \
      interested and Matt will make your sponsor arrangements.",
  },
  {
    path: '/accommodations/modern',
    name: 'Modern Honolulu',
    location: 'Honolulu',
    address: '1775 Ala Moana Boulevard, Honolulu',
    mapUrl: 'https://goo.gl/maps/U4b5R3HgN6z',
    roomRate: 'TBD',
    promoCode: '--',
    travelTime: 54,
    url: 'https://www.themodernhonolulu.com',
    imgPath: '/img/accommodations_modern.jpg',
    description: 'Details to come.',
  },
  {
    path: '/accommodations/airbnb',
    name: 'Airbnb',
    location: 'Other',
    url: 'https://www.airbnb.com/s/oahu--hi/homes?checkin=2018-05-18&checkout=2018-05-20',
    imgPath: '/img/accommodations_airbnb.jpg',
    description:
      'Recommend that you stay on the Northshore for convenience. Tons of great places, all over the island. This is \
      the most authentic way to experience the island.',
  },
];

export type AccommodationGroupData = Pick<AccommodationData, 'path' | 'name'>;
type AccommodationsReducer = { [L in Location]: AccommodationGroupData[] };

const reducedAccommodations = accommodations.reduce(
  (agg, { path, name, location }) => {
    if (agg[location]) {
      agg[location].push({ path, name });
    } else {
      agg[location] = [{ path, name }];
    }
    return agg;
  },
  {} as AccommodationsReducer,
);

export interface AccommodationsGroup {
  location: Location;
  accommodations: AccommodationGroupData[];
}

export const groupedAccommodations = (Object.keys(reducedAccommodations) as Location[]).reduce(
  (agg, location) => {
    agg.push({ location, accommodations: reducedAccommodations[location] });
    return agg;
  },
  [] as AccommodationsGroup[],
);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/data/accommodations.ts